import {useCallback} from 'react';
import {useTimeoutRef} from '@chekinapp/ui';
import {SPLASH_QUERY_PARAM} from 'components/SplashScreen/constants';
import {rememberBootBackdrop} from 'utils/firstScreen';

const REDIRECT_DELAY_MS = 3800;

function withoutEntrance(link: string) {
  const url = new URL(link, window.location.origin);
  url.searchParams.set(SPLASH_QUERY_PARAM, 'false');
  return url.toString();
}

function useBookingFoundRedirect() {
  const timeoutRef = useTimeoutRef();

  const scheduleCheckIn = useCallback(
    (link: string) => {
      timeoutRef.current = setTimeout(() => {
        rememberBootBackdrop();
        window.location.href = withoutEntrance(link);
      }, REDIRECT_DELAY_MS);
    },
    [timeoutRef],
  );

  return {scheduleCheckIn};
}

export {REDIRECT_DELAY_MS, useBookingFoundRedirect};
